import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  rules: [],
  pagination: {},
  loading: false,
  fetchingRules: false,
  reservationLoading: false,
  fetchedReservationError: false,
  fetchedReservationSuccess: false,
  startReservationSuccess: false,
  endReservationSuccess: false,
  cancelReservationSuccess: false,
  createReservationError: false,
  reservations: [],
  reservation: {},
  businessHours: [],
  fetchingBusinessHours: false,
};

const reservationsReducer = createReducer(initialState)({
  // GET RESERVATIONS
  [types.FETCH_RESERVATIONS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_RESERVATIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      reservations: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_RESERVATIONS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  // GET RESERVATION BY ID
  [types.FETCH_RESERVATION_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      reservationLoading: true,
    };
  },
  [types.FETCH_RESERVATION_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      reservationLoading: false,
      reservation: payload,
    };
  },
  [types.FETCH_RESERVATION_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      reservationLoading: false,
    };
  },
  // CREATE RESERVATION
  [types.FETCH_CREATE_RESERVATION_REQUEST]: (state) => {
    return {
      ...state,
      reservationLoading: true,
    };
  },
  [types.FETCH_CREATE_RESERVATION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      reservationLoading: false,
      fetchedReservationSuccess: true,
      reservation: payload,
    };
  },
  [types.FETCH_CREATE_RESERVATION_FAILED]: (state) => {
    return {
      ...state,
      reservationLoading: false,
      createReservationError: true,
    };
  },
  // UPDATE RESERVATION
  [types.FETCH_UPDATE_RESERVATION_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      reservationLoading: true,
      fetchedReservationError: false,
    };
  },
  [types.FETCH_UPDATE_RESERVATION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      reservation: payload,
      reservationLoading: false,
      fetchedReservationError: false,
      fetchedReservationSuccess: true,
    };
  },
  [types.FETCH_UPDATE_RESERVATION_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      reservationLoading: false,
      errors: payload?.errors || {},
      fetchedReservationError: true,
    };
  },
  // GET RESERVATIONS RULES
  [types.FETCH_RESERVATIONS_RULES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingRules: true,
    };
  },
  [types.FETCH_RESERVATIONS_RULES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingRules: false,
      rules: payload.data || [],
    };
  },
  [types.FETCH_RESERVATIONS_RULES_FAILED]: (state) => {
    return {
      ...state,
      fetchingRules: false,
    };
  },
  // START RESERVATION
  [types.START_RESERVATION_REQUEST]: (state) => {
    return {
      ...state,
      reservationLoading: true,
    };
  },
  [types.START_RESERVATION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      reservationLoading: false,
      startReservationSuccess: true,
      reservation: payload.data,
    };
  },
  [types.START_RESERVATION_FAILED]: (state) => {
    return {
      ...state,
      reservationLoading: false,
    };
  },
  // END RESERVATION
  [types.END_RESERVATION_REQUEST]: (state) => {
    return {
      ...state,
      reservationLoading: true,
    };
  },
  [types.END_RESERVATION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      reservationLoading: false,
      endReservationSuccess: true,
      reservation: payload.data,
    };
  },
  [types.END_RESERVATION_FAILED]: (state) => {
    return {
      ...state,
      reservationLoading: false,
    };
  },
  // CANCEL RESERVATION
  [types.CANCEL_RESERVATION_REQUEST]: (state) => {
    return {
      ...state,
      reservationLoading: true,
    };
  },
  [types.CANCEL_RESERVATION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      reservationLoading: false,
      cancelReservationSuccess: true,
      reservation: payload.data,
    };
  },
  [types.CANCEL_RESERVATION_FAILED]: (state) => {
    return {
      ...state,
      reservationLoading: false,
    };
  },
  [types.RESET_UPDATE_RESERVATION]: (state) => {
    return {
      ...state,
      reservation: {},
      reservationLoading: false,
      endReservationSuccess: false,
      createReservationError: false,
      startReservationSuccess: false,
      cancelReservationSuccess: false,
      fetchedReservationSuccess: false,
    };
  },

  [types.FETCH_BUSINESS_HOURS_REQUEST]: (state) => {
    return {
      ...state,
      businessHours: [],
      fetchingBusinessHours: true,
    };
  },
  [types.FETCH_BUSINESS_HOURS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      businessHours: payload.data,
      fetchingBusinessHours: false,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_BUSINESS_HOURS_FAILED]: (state, { errors }) => {
    return {
      ...state,
      errors: errors,
      fetchingBusinessHours: false,
    };
  },
});

export default reservationsReducer;
